// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"numberedStoryHeadline-m__wrapper__1i1wo","content":"numberedStoryHeadline-m__content__2Lmzu","number":"numberedStoryHeadline-m__number__3Elee"};